import { useMemo } from "react";
import { IFilterSchema, ITableSchema } from "../utils/types";
import useUrlFilters from "./useUrlFilter";
import { useLocation } from "react-router-dom";
import useUrlSort from "./useUrlSort";

function useTableSchema(tableSchema: ITableSchema[]) {
  const { getFilterValue, getFilterOperator } = useUrlFilters();
  const location = useLocation();
  const { getSortValue } = useUrlSort();

  const columns: ITableSchema[] = useMemo(() => {
    return tableSchema
      .filter((column) => column.visible !== false)
      .map((column) => ({
        key: column.key,
        label: column.label,
        align: column.align,
        sortable: column.sortable ?? false,
        sortDirection: getSortValue(column.key)?.direction ?? null,
        minWidth: column.minWidth ?? 120,
        format: column.format,
      }));
  }, [tableSchema, location]);

  const filtersSchema: IFilterSchema[] = useMemo(() => {
    return tableSchema
      .filter((column) => column.FilterComponent)
      .map((column) => ({
        FilterComponent: column.FilterComponent as React.ElementType,
        props: {
          columnName: column.key,
          label: column.label,
          value: getFilterValue(column.key),
          operator: getFilterOperator(column.key),
        },
        ...(column.options && { options: column.options }),
      }));
  }, [tableSchema, location]);

  return { filtersSchema, columns };
}

export default useTableSchema;
